export default __webpack_public_path__ + "static/media/booksheader.6819dd11.png";